<template>
  <div>
    <section class="page-content">
      <form action @submit.prevent="next">
        <div v-if="groupAppraiser.wouldLikeCoverageForBothAppraisingAndSales == true || groupAppraiser.wouldLikeCoverageForBothAppraisingAndSales === 'true'">
          <article class="d-flex flex-column justify-content-center form-heading title-section form-section">
            <h1 class="font-weight-bold text-center w-75">REAL ESTATE AGENT</h1>
          </article>
          <article class="input-section form-section">
            <div class="flex">
              <div class="col-md-9">
                <label for class="orep-label">
                  Are you licensed as a real estate agent/broker?
                </label>
              </div>
              <div class="col-md-3 d-flex flex-column">
                <div class="d-flex flex-row">
                  <div class="radio orep-radio-wrapper">
                    <label>
                      <input
                        type="radio"
                        name="areLicensedAsRealEstateAgent"
                        value="true"
                        class="orep-radio"
                        v-validate="'required'"
                        @change="validateBeforeSubmit()"
                        v-model="groupAppraiser.areLicensedAsRealEstateAgent"
                      >
                      <span class="radio-span">Yes</span>
                    </label>
                  </div>
                  <div class="radio orep-radio-wrapper">
                    <label>
                      <input
                        type="radio"
                        name="areLicensedAsRealEstateAgent"
                        value="false"
                        class="orep-radio"
                        @change="validateBeforeSubmit()"
                        v-model="groupAppraiser.areLicensedAsRealEstateAgent"
                      >
                      <span class="radio-span">No</span>
                    </label>
                  </div>
                </div>
                <span
                  v-show="errors.has('areLicensedAsRealEstateAgent')"
                  class="help is-danger form-errors text-danger"
                >{{ errors.first('areLicensedAsRealEstateAgent') | filterText }}</span>
              </div>
            </div>
          </article>
          <article class="input-section form-section">
            <div class="flex">
              <div class="col-md-9">
                <label for class="orep-label">
                  <span class="mr-1">A.</span>
                  Does the applicant have documented procedures which include instructions on how to handle
  complaints and compliance with Federal, State and Local statutes?
                </label>
              </div>
              <div class="col-md-3 d-flex flex-column">
                <div class="d-flex flex-row">
                  <div class="radio orep-radio-wrapper">
                    <label>
                      <input
                        type="radio"
                        name="doesApplicantHaveDocumentedProcedures"
                        value="true"
                        class="orep-radio"
                        v-validate="'required'"
                        @change="validateBeforeSubmit()"
                        v-model="groupAppraiser.doesApplicantHaveDocumentedProcedures"
                      >
                      <span class="radio-span">Yes</span>
                    </label>
                  </div>
                  <div class="radio orep-radio-wrapper">
                    <label>
                      <input
                        type="radio"
                        name="doesApplicantHaveDocumentedProcedures"
                        value="false"
                        class="orep-radio"
                        @change="validateBeforeSubmit()"
                        v-model="groupAppraiser.doesApplicantHaveDocumentedProcedures"
                      >
                      <span class="radio-span">No</span>
                    </label>
                  </div>
                </div>
                <span
                  v-show="errors.has('doesApplicantHaveDocumentedProcedures')"
                  class="help is-danger form-errors text-danger"
                >{{ errors.first('doesApplicantHaveDocumentedProcedures') | filterText }}</span>
              </div>
            </div>
          </article>
          <article class="input-section form-section d-flex flex-column">
            <div class="flex">
              <div class="col-md-9">
                <label for class="orep-label">
                  <span class="mr-1">B.</span>
                  Does the applicant use approved board of REALTORS® or state association of REALTORS® standard
  contract forms for the listing and sale of all Real Estate?
                </label>
              </div>
              <div class="col-md-3 d-flex flex-column">
                <div class="d-flex flex-row">
                  <div class="radio orep-radio-wrapper">
                    <label>
                      <input
                        type="radio"
                        name="doesApplicantUseApprovedBoradOfRealtors"
                        value="true"
                        class="orep-radio"
                        v-validate="'required'"
                        @change="validateBeforeSubmit()"
                        v-model="groupAppraiser.doesApplicantUseApprovedBoradOfRealtors"
                      >
                      <span class="radio-span">Yes</span>
                    </label>
                  </div>
                  <div class="radio orep-radio-wrapper">
                    <label>
                      <input
                        type="radio"
                        name="doesApplicantUseApprovedBoradOfRealtors"
                        value="false"
                        class="orep-radio"
                        @change="validateBeforeSubmit()"
                        v-model="groupAppraiser.doesApplicantUseApprovedBoradOfRealtors"
                      >
                      <span class="radio-span">No</span>
                    </label>
                  </div>
                </div>
                <span
                  v-show="errors.has('doesApplicantUseApprovedBoradOfRealtors')"
                  class="help is-danger form-errors text-danger"
                >{{ errors.first('doesApplicantUseApprovedBoradOfRealtors') | filterText }}</span>
              </div>
            </div>
            <input
              type="text"
              placeholder="Please explain:"
              class="orep-text-input js-orep-input"
              v-if="groupAppraiser.doesApplicantUseApprovedBoradOfRealtors === 'no'"
              name="doesApplicantUseApprovedBoradOfRealtorsDetails"
              v-model="groupAppraiser.doesApplicantUseApprovedBoradOfRealtorsDetails"
            >
          </article>
          <article class="input-section form-section">
            <label for class="orep-label">
              <span class="mr-1">C.</span>
              In the past year, what was the average value of properties sold/purchased by applicant?
            </label>
            <input
              type="text"
              name="averageValueOfPropertiesSoldByApplicant"
              v-model="groupAppraiser.averageValueOfPropertiesSoldByApplicant"
              class="orep-text-input"
              v-validate="'required'"
              @input="validateBeforeSubmit()"
            >
            <span
              v-show="errors.has('averageValueOfPropertiesSoldByApplicant')"
              class="help is-danger form-errors text-danger"
            >{{ errors.first('averageValueOfPropertiesSoldByApplicant') | filterText }}</span>
          </article>
          <article class="input-section form-section">
            <label class="orep-label">
              <span class="mr-1">D.</span>What percentage of residential transactions included:
            </label>
            <div class="d-flex align-items-center py-2">
              <label class="mb-0" style="width: 300px;">a. Signed property disclosure form?</label>
              <input
                type="text"
                name="signedPropertyDisclosureForm"
                v-model="groupAppraiser.signedPropertyDisclosureForm"
                class="orep-text-input ml-3 mr-1"
                v-validate="'required'"
                @input="validateBeforeSubmit()"
                style="width: 50px;"
              >
              <label class="mb-0 mr-4">%</label>
              <span
                v-show="errors.has('signedPropertyDisclosureForm')"
                class="help is-danger form-errors text-danger"
              >{{ errors.first('signedPropertyDisclosureForm') | filterText }}</span>
            </div>
            <div class="d-flex align-items-center py-2">
              <label class="mb-0" style="width: 300px;">b. Home inspection or written waiver?</label>
              <input
                type="text"
                name="homeInspectionOrWrittenWaiver"
                v-model="groupAppraiser.homeInspectionOrWrittenWaiver"
                class="orep-text-input ml-3 mr-1"
                v-validate="'required'"
                @input="validateBeforeSubmit()"
                style="width: 50px;"
              >
              <label class="mb-0 mr-4">%</label>
              <span
                v-show="errors.has('homeInspectionOrWrittenWaiver')"
                class="help is-danger form-errors text-danger"
              >{{ errors.first('homeInspectionOrWrittenWaiver') | filterText }}</span>
            </div>
            <div class="d-flex align-items-center py-2">
              <label class="mb-0" style="width: 300px;">c. Home warranty program?</label>
              <input
                type="text"
                name="homeWarrantyProgram"
                v-model="groupAppraiser.homeWarrantyProgram"
                class="orep-text-input ml-3 mr-1"
                v-validate="'required'"
                @input="validateBeforeSubmit()"
                style="width: 50px;"
              >
              <label class="mb-0 mr-4">%</label>
              <span
                v-show="errors.has('homeWarrantyProgram')"
                class="help is-danger form-errors text-danger"
              >{{ errors.first('homeWarrantyProgram') | filterText }}</span>
            </div>
          </article>
          <article class="input-section form-section d-flex flex-column">
            <div class="flex">
              <div class="col-md-9">
                <label for class="orep-label">
                  <span class="mr-1">E.</span>
                  Do you have any ownership interest in any property being managed, purchased, or held for sale?
                </label>
              </div>
              <div class="col-md-3 d-flex flex-column">
                <div class="d-flex flex-row">
                  <div class="radio orep-radio-wrapper">
                    <label>
                      <input
                        type="radio"
                        name="haveAnyOwnershipInterestInAnyProperty"
                        value="true"
                        class="orep-radio"
                        v-validate="'required'"
                        @change="validateBeforeSubmit()"
                        v-model="groupAppraiser.haveAnyOwnershipInterestInAnyProperty"
                      >
                      <span class="radio-span">Yes</span>
                    </label>
                  </div>
                  <div class="radio orep-radio-wrapper">
                    <label>
                      <input
                        type="radio"
                        name="haveAnyOwnershipInterestInAnyProperty"
                        value="false"
                        class="orep-radio"
                        @change="validateBeforeSubmit()"
                        v-model="groupAppraiser.haveAnyOwnershipInterestInAnyProperty"
                      >
                      <span class="radio-span">No</span>
                    </label>
                  </div>
                </div>
                <span
                  v-show="errors.has('haveAnyOwnershipInterestInAnyProperty')"
                  class="help is-danger form-errors text-danger"
                >{{ errors.first('haveAnyOwnershipInterestInAnyProperty') | filterText }}</span>
              </div>
            </div>
            <input
              type="text"
              placeholder="Please explain:"
              class="orep-text-input js-orep-input"
              v-if="groupAppraiser.haveAnyOwnershipInterestInAnyProperty == true || groupAppraiser.haveAnyOwnershipInterestInAnyProperty === 'true'"
              name="haveAnyOwnershipInterestInAnyPropertyDetails"
              v-model="groupAppraiser.haveAnyOwnershipInterestInAnyPropertyDetails"
            >
          </article>
        </div>

        <article class="d-flex flex-column justify-content-center form-heading title-section form-section">
          <h1 class="font-weight-bold text-center w-75">PART 4: COVERAGE INFORMATION</h1>
        </article>
        <article class="input-section form-section d-flex flex-column">
          <div class="flex">
            <div class="col-md-9">
              <label for class="orep-label">
                <span class="mr-1">17.</span>
                Do you currently carry Professional Liability (Errors and Omissions) insurance?
              </label>
            </div>
            <div class="col-md-3 d-flex flex-column">
              <div class="d-flex flex-row">
                <div class="radio orep-radio-wrapper">
                  <label>
                    <input
                      type="radio"
                      name="doYouCurrentlyCarryProfessionalLiabilityInsurance"
                      value="true"
                      class="orep-radio"
                      v-validate="'required'"
                      @change="validateBeforeSubmit()"
                      v-model="groupAppraiser.doYouCurrentlyCarryProfessionalLiabilityInsurance"
                    >
                    <span class="radio-span">Yes</span>
                  </label>
                </div>
                <div class="radio orep-radio-wrapper">
                  <label>
                    <input
                      type="radio"
                      name="doYouCurrentlyCarryProfessionalLiabilityInsurance"
                      value="false"
                      class="orep-radio"
                      @change="validateBeforeSubmit()"
                      v-model="groupAppraiser.doYouCurrentlyCarryProfessionalLiabilityInsurance"
                    >
                    <span class="radio-span">No</span>
                  </label>
                </div>
              </div>
              <span
                v-show="errors.has('doYouCurrentlyCarryProfessionalLiabilityInsurance')"
                class="help is-danger form-errors text-danger"
              >{{ errors.first('doYouCurrentlyCarryProfessionalLiabilityInsurance') | filterText }}</span>
            </div>
          </div>
          <div class="ml-3" v-if="groupAppraiser.doYouCurrentlyCarryProfessionalLiabilityInsurance === 'true' || groupAppraiser.doYouCurrentlyCarryProfessionalLiabilityInsurance == true">
            <p class="mb-0">Your Retroactive Date is:</p>
            <div class="col-md-4">
              <datepicker
                name="retroactiveDate"
                v-model="groupAppraiser.retroactiveDate"
                format="MM/dd/yyyy"
                input-class="orep-text-input w-75"
                clear-button
              ></datepicker>

            </div>

          </div>
        </article>
        <article class="input-section form-section">
          <label class="orep-label">
            <span class="mr-2">18.</span>
            Limits Of Liability Per Claim / Aggregate (Applicant may check more than one)
          </label>
          <div class="radio orep-radio-wrapper">
            <div class="radio orep-radio-wrapper solo-checkbox">
              <label>
                <input
                  type="checkbox"
                  class="orep-radio"
                  name="limitOfCoverages"
                  value="0.25M/0.25M"
                  :checked="groupAppraiser.limitOfCoverages.find(coverage => coverage === '0.25M/0.25M')"
                  v-validate="'required|included:1M/1M,0.5M/0.5M,0.25M/0.25M,1M/2M'"
                  @change="validateBeforeSubmit() + desiredCoverage($event)"
                >
                <span class="radio-span solo-checkbox-span">$250,000 / $250,000</span>
              </label>
            </div>
            <div class="radio orep-radio-wrapper solo-checkbox">
              <label>
                <input
                  type="checkbox"
                  name="limitOfCoverages"
                  value="0.5M/0.5M"
                  class="orep-radio"
                  :checked="groupAppraiser.limitOfCoverages.find(coverage => coverage === '0.5M/0.5M')"
                  @change="validateBeforeSubmit() + desiredCoverage($event)"
                >
                <span class="radio-span solo-checkbox-span">$500,000 / $500,000</span>
              </label>
            </div>
            <div class="radio orep-radio-wrapper solo-checkbox">
              <label>
                <input
                  type="checkbox"
                  name="limitOfCoverages"
                  value="1M/1M"
                  class="orep-radio"
                  :checked="groupAppraiser.limitOfCoverages.find(coverage => coverage === '1M/1M')"
                  @change="validateBeforeSubmit() + desiredCoverage($event)"
                >
                <span class="radio-span solo-checkbox-span">$1,000,000 / $1,000,000</span>
              </label>
            </div>
            <div class="radio orep-radio-wrapper solo-checkbox">
              <label>
                <input
                  type="checkbox"
                  name="limitOfCoverages"
                  value="1M/2M"
                  class="orep-radio"
                  :checked="groupAppraiser.limitOfCoverages.find(coverage => coverage === '1M/2M')"
                  @change="validateBeforeSubmit() + desiredCoverage($event)"
                >
                <span class="radio-span solo-checkbox-span">$1,000,000 / $2,000,000</span>
              </label>
            </div>
          </div>
          <p class="font-weight-bold mb-0 mt-3">
            NOTE: Many lenders/Financial Institutions require Minimum Aggregate Limit of $1,000,000.
          </p>
          <p class="mb-0">
            (Raising limits mid-term is done by endorsement and can take up to several days to process.)
          </p>
        </article>
        <article class="input-section form-section">
          <label class="orep-label">
            <span class="mr-2">19.</span>
            Deductible (Applicant may check more than one)
          </label>
          <div class="radio orep-radio-wrapper">
            <div class="radio orep-radio-wrapper solo-checkbox">
              <label>
                <input
                  type="checkbox"
                  class="orep-radio"
                  name="deductible"
                  value="$1000"
                  v-model="groupAppraiser.deductible"
                >
                <span class="radio-span solo-checkbox-span">$1,000 Each claim</span>
              </label>
            </div>
            <div class="radio orep-radio-wrapper solo-checkbox">
              <label>
                <input
                  type="checkbox"
                  name="deductible"
                  value="$2500"
                  class="orep-radio"
                  v-model="groupAppraiser.deductible"
                >
                <span class="radio-span solo-checkbox-span">$2,500 Each claim</span>
              </label>
            </div>
            <div class="radio orep-radio-wrapper solo-checkbox">
              <label>
                <input
                  type="checkbox"
                  name="deductible"
                  value="$5000"
                  class="orep-radio"
                  v-model="groupAppraiser.deductible"
                >
                <span class="radio-span solo-checkbox-span">$5,000 Each claim</span>
              </label>
            </div>
          </div>
        </article>
        <article class="input-section form-section">
          <label class="orep-label">
            <span class="mr-2">20.</span>
            Optional Coverage
          </label>
          <div class="flex">
            <div class="col-md-9">
              <label for class="orep-label">
                <span class="mr-1">20a.</span>
                Do you want Real Estate Appraisal Management Company Extension? (Adds 10% of Premium)
              </label>
            </div>
            <div class="col-md-3 d-flex flex-column">
              <div class="d-flex flex-row">
                <div class="radio orep-radio-wrapper">
                  <label>
                    <input
                      type="radio"
                      name="wantRealEstateAppraisalManagementCompanyExtension"
                      value="true"
                      class="orep-radio"
                      v-validate="'required'"
                      @change="validateBeforeSubmit()"
                      v-model="groupAppraiser.wantRealEstateAppraisalManagementCompanyExtension"
                    >
                    <span class="radio-span">Yes</span>
                  </label>
                </div>
                <div class="radio orep-radio-wrapper">
                  <label>
                    <input
                      type="radio"
                      name="wantRealEstateAppraisalManagementCompanyExtension"
                      value="false"
                      class="orep-radio"
                      @change="validateBeforeSubmit()"
                      v-model="groupAppraiser.wantRealEstateAppraisalManagementCompanyExtension"
                    >
                    <span class="radio-span">No</span>
                  </label>
                </div>
              </div>
              <span
                v-show="errors.has('wantRealEstateAppraisalManagementCompanyExtension')"
                class="help is-danger form-errors text-danger"
              >{{ errors.first('wantRealEstateAppraisalManagementCompanyExtension') | filterText }}</span>
            </div>
          </div>
          <div class="flex">
            <div class="col-md-9">
              <label for class="orep-label font-weight-normal">
                <span class="mr-1 font-weight-bold">20b: </span>
                <strong>
                  <span class="text-underline">Important Coverage Note:</span>
                </strong>
                If you’d like a quote on a low-cost General Liability (GL) policy that includes Loss of Income coverage, Personal Property coverage (computers, client records, buildings) and Employee Dishonesty, please check this box. Premiums range from $175 - $500. The separate GL quote will follow and will not delay the processing of this E&O coverage.
              </label>
            </div>
            <div class="col-md-3 d-flex flex-column">
              <div class="d-flex flex-row">
                <div class="radio orep-radio-wrapper">
                  <label>
                    <input
                      type="radio"
                      name="sendMeInformationOnCoverage"
                      value="true"
                      class="orep-radio"
                      v-validate="'required'"
                      @change="validateBeforeSubmit()"
                      v-model="groupAppraiser.sendMeInformationOnCoverage"
                    >
                    <span class="radio-span">Yes</span>
                  </label>
                </div>
                <div class="radio orep-radio-wrapper">
                  <label>
                    <input
                      type="radio"
                      name="sendMeInformationOnCoverage"
                      value="false"
                      class="orep-radio"
                      @change="validateBeforeSubmit()"
                      v-model="groupAppraiser.sendMeInformationOnCoverage"
                    >
                    <span class="radio-span">No</span>
                  </label>
                </div>
              </div>
              <span
                v-show="errors.has('sendMeInformationOnCoverage')"
                class="help is-danger form-errors text-danger"
              >{{ errors.first('sendMeInformationOnCoverage') | filterText }}</span>
            </div>
          </div>
        </article>

        <article class="d-flex flex-column justify-content-center form-heading title-section form-section">
          <h1 class="font-weight-bold text-center w-75">PART 5: HISTORY</h1>
        </article>
        <article class="input-section form-section">
          <div class="flex wrap history">
            <div class="flex history-toggle w-100">
              <div class="col-md-9">
                <label for class="orep-label history-label">
                  <span class="qtn mrpx-5">21.</span>
                  Has any application or policy for similar professional liability insurance on behalf of the Applicant,
partners, officers or employees or on behalf of predecessors in business ever been declined, cancelled,
or renewal refused? MISSOURI APPLICANTS NEED NOT REPLY.
                </label>
              </div>
              <div class="col-md-3 d-flex flex-column">
                <div class="d-flex flex-row">
                  <div class="radio orep-radio-wrapper">
                <label>
                  <input
                    type="radio"
                    name="hasAnyApplicationEverBeenDeclined"
                    value="true"
                    class="orep-radio"
                    v-validate="'required'"
                    @change="validateBeforeSubmit()"
                    v-model="groupAppraiser.hasAnyApplicationEverBeenDeclined"
                  >
                  <span class="radio-span">Yes</span>
                </label>
              </div>
                  <div class="radio orep-radio-wrapper">
                    <label>
                      <input
                        type="radio"
                        name="hasAnyApplicationEverBeenDeclined"
                        value="false"
                        class="orep-radio"
                        @change="validateBeforeSubmit()"
                        v-model="groupAppraiser.hasAnyApplicationEverBeenDeclined"
                      >
                      <span class="radio-span">No</span>
                    </label>
                  </div>
                </div>
                <span
                  v-show="errors.has('hasAnyApplicationEverBeenDeclined')"
                  class="help is-danger form-errors text-danger"
                >{{ errors.first('hasAnyApplicationEverBeenDeclined') | filterText }}</span>
              </div>
            </div>
            <p
              v-show="groupAppraiser.hasAnyApplicationEverBeenDeclined === 'true' || groupAppraiser.hasAnyApplicationEverBeenDeclined == true"
              class="input-info"
            >
              <i class="fas fa-exclamation-triangle not-eligible"></i>
              <span
                class="not-eligible-text"
              >Please provide details in Explanation Section below.</span>
            </p>
          </div>
        </article>
        <article class="input-section form-section">
          <div class="flex wrap history">
            <div class="flex history-toggle w-100">
              <div class="col-md-9">
                <label for class="orep-label history-label">
                  <span class="qtn mrpx-5">22.</span>
                  Is the Applicant or any of the individuals listed in Part 2, aware of any circumstance, incident or
complaint which may lead to the filing of a claim or disciplinary action against the Applicant or against any
individuals listed in Part 2 <span class="text-underline">within the last five years?</span>
                </label>
              </div>
              <div class="col-md-3 d-flex flex-column">
                <div class="d-flex flex-row">
                  <div class="radio orep-radio-wrapper">
                    <label>
                      <input
                        type="radio"
                        name="isApplicantListInPart2AwareOfAnyCircumstance"
                        value="true"
                        class="orep-radio"
                        v-validate="'required'"
                        @change="validateBeforeSubmit()"
                        v-model="groupAppraiser.isApplicantListInPart2AwareOfAnyCircumstance"
                      >
                      <span class="radio-span">Yes</span>
                    </label>
                  </div>
                  <div class="radio orep-radio-wrapper">
                    <label>
                      <input
                        type="radio"
                        name="isApplicantListInPart2AwareOfAnyCircumstance"
                        value="false"
                        class="orep-radio"
                        @change="validateBeforeSubmit()"
                        v-model="groupAppraiser.isApplicantListInPart2AwareOfAnyCircumstance"
                      >
                      <span class="radio-span">No</span>
                    </label>
                  </div>
                </div>
                <span
                  v-show="errors.has('isApplicantListInPart2AwareOfAnyCircumstance')"
                  class="help is-danger form-errors text-danger"
                >{{ errors.first('isApplicantListInPart2AwareOfAnyCircumstance') | filterText }}</span>
              </div>
            </div>
            <p
              v-show="groupAppraiser.isApplicantListInPart2AwareOfAnyCircumstance === 'true' || groupAppraiser.isApplicantListInPart2AwareOfAnyCircumstance == true"
              class="input-info"
            >
              <i class="fas fa-exclamation-triangle not-eligible"></i>
              <span
                class="not-eligible-text"
              >Please provide details in Explanation Section below.</span>
            </p>
          </div>
        </article>
        <article class="input-section form-section">
          <div class="flex wrap history">
            <div class="flex history-toggle w-100">
              <div class="col-md-9">
                <label for class="orep-label history-label">
                  <span class="qtn mrpx-5">23.</span>
                  Have any claims ever been made against the Applicant, or against any individuals listed in Part 2 <span class="text-underline">within the last five years?</span>
                </label>
              </div>
              <div class="col-md-3 d-flex flex-column">
                <div class="d-flex flex-row">
                  <div class="radio orep-radio-wrapper">
                <label>
                  <input
                    type="radio"
                    name="haveAnyClaimsEverBeenMadeAgainstApplicant"
                    value="true"
                    class="orep-radio"
                    v-validate="'required'"
                    @change="validateBeforeSubmit()"
                    v-model="groupAppraiser.haveAnyClaimsEverBeenMadeAgainstApplicant"
                  >
                  <span class="radio-span">Yes</span>
                </label>
              </div>
                  <div class="radio orep-radio-wrapper">
                    <label>
                      <input
                        type="radio"
                        name="haveAnyClaimsEverBeenMadeAgainstApplicant"
                        value="false"
                        class="orep-radio"
                        @change="validateBeforeSubmit()"
                        v-model="groupAppraiser.haveAnyClaimsEverBeenMadeAgainstApplicant"
                      >
                      <span class="radio-span">No</span>
                    </label>
                  </div>
                </div>
                <span
                  v-show="errors.has('haveAnyClaimsEverBeenMadeAgainstApplicant')"
                  class="help is-danger form-errors text-danger"
                >{{ errors.first('haveAnyClaimsEverBeenMadeAgainstApplicant') | filterText }}</span>
              </div>
            </div>
            <p
              v-show="groupAppraiser.haveAnyClaimsEverBeenMadeAgainstApplicant === 'true' || groupAppraiser.haveAnyClaimsEverBeenMadeAgainstApplicant == true"
              class="input-info"
            >
              <i class="fas fa-exclamation-triangle not-eligible"></i>
              <span
                class="not-eligible-text"
              >Please attach a completed Claims Supplement for each claim along with a current loss run</span>
            </p>
          </div>
        </article>
        <article class="input-section form-section">
          <div class="flex wrap history">
            <div class="flex history-toggle w-100">
              <div class="col-md-9">
                <label for class="orep-label history-label">
                  <span class="qtn mrpx-5">24.</span>
                  Has the Applicant or any of the individuals listed in Part 2 been the subject of a disciplinary action by
any real estate or appraiser association, state licensing board, or other regulatory body, as a result of
professional activities <span class="text-underline">within the last five years?</span>
                </label>
              </div>
              <div class="col-md-3 d-flex flex-column">
                <div class="d-flex flex-row">
                  <div class="radio orep-radio-wrapper">
                <label>
                  <input
                    type="radio"
                    name="hasApplicantListedPart2BeenSubjectOfDisciplinaryAction"
                    value="true"
                    class="orep-radio"
                    v-validate="'required'"
                    @change="validateBeforeSubmit()"
                    v-model="groupAppraiser.hasApplicantListedPart2BeenSubjectOfDisciplinaryAction"
                  >
                  <span class="radio-span">Yes</span>
                </label>
              </div>
                  <div class="radio orep-radio-wrapper">
                    <label>
                      <input
                        type="radio"
                        name="hasApplicantListedPart2BeenSubjectOfDisciplinaryAction"
                        value="false"
                        class="orep-radio"
                        @change="validateBeforeSubmit()"
                        v-model="groupAppraiser.hasApplicantListedPart2BeenSubjectOfDisciplinaryAction"
                      >
                      <span class="radio-span">No</span>
                    </label>
                  </div>
                </div>
                <span
                  v-show="errors.has('hasApplicantListedPart2BeenSubjectOfDisciplinaryAction')"
                  class="help is-danger form-errors text-danger"
                >{{ errors.first('hasApplicantListedPart2BeenSubjectOfDisciplinaryAction') | filterText }}</span>
              </div>
            </div>
            <p
              v-show="groupAppraiser.hasApplicantListedPart2BeenSubjectOfDisciplinaryAction === 'true' || groupAppraiser.hasApplicantListedPart2BeenSubjectOfDisciplinaryAction == true"
              class="input-info"
            >
              <i class="fas fa-exclamation-triangle not-eligible"></i>
              <span
                class="not-eligible-text"
              >Please attach a completed Claims Supplement for each claim along with a current loss run</span>
            </p>
          </div>
        </article>
        <article class="input-section form-section">
          <div class="flex wrap history">
            <div class="flex history-toggle w-100">
              <div class="col-md-9">
                <label for class="orep-label history-label">
                  <span class="qtn mrpx-5">25.</span>
                  The applicant is not currently, and has not during the last five (5) years, operated under any chapter of the United States bankruptcy code.
                </label>
              </div>
              <div class="col-md-3 d-flex flex-column">
                <div class="d-flex flex-row">
                  <div class="radio orep-radio-wrapper">
                    <label>
                      <input
                        type="radio"
                        name="usBankruptcyCode"
                        value="true"
                        class="orep-radio"
                        v-validate="'required'"
                        @change="validateBeforeSubmit()"
                        v-model="groupAppraiser.usBankruptcyCode"
                      >
                      <span class="radio-span">True</span>
                    </label>
                  </div>
                  <div class="radio orep-radio-wrapper">
                    <label>
                      <input
                        type="radio"
                        name="usBankruptcyCode"
                        value="false"
                        class="orep-radio"
                        @change="validateBeforeSubmit()"
                        v-model="groupAppraiser.usBankruptcyCode"
                      >
                      <span class="radio-span">False</span>
                    </label>
                  </div>
                </div>
                <span
                  v-show="errors.has('usBankruptcyCode')"
                  class="help is-danger form-errors text-danger"
                >{{ errors.first('usBankruptcyCode') | filterText }}</span>
              </div>
            </div>

          </div>
        </article>
        <article class="input-section form-section">
          <div class="flex wrap history">
            <div class="flex history-toggle w-100">
              <div class="col-md-9">
                <label for class="orep-label history-label">
                  <span class="qtn mrpx-5">26.</span>
                  The applicant does not have similar insurance which is in the process of being cancelled or non-renewed.
                </label>
              </div>
              <div class="col-md-3 d-flex flex-column">
                <div class="d-flex flex-row">
                  <div class="radio orep-radio-wrapper">
                    <label>
                      <input
                        type="radio"
                        name="insuranceAppStatus"
                        value="true"
                        class="orep-radio"
                        v-validate="'required'"
                        @change="validateBeforeSubmit()"
                        v-model="groupAppraiser.insuranceAppStatus"
                      >
                      <span class="radio-span">True</span>
                    </label>
                  </div>
                  <div class="radio orep-radio-wrapper">
                    <label>
                      <input
                        type="radio"
                        name="insuranceAppStatus"
                        value="false"
                        class="orep-radio"
                        @change="validateBeforeSubmit()"
                        v-model="groupAppraiser.insuranceAppStatus"
                      >
                      <span class="radio-span">False</span>
                    </label>
                  </div>
                </div>
                <span
                  v-show="errors.has('insuranceAppStatus')"
                  class="help is-danger form-errors text-danger"
                >{{ errors.first('insuranceAppStatus') | filterText }}</span>
              </div>
            </div>
          </div>
        </article>

        <article class="input-section form-section">
          <label for class="orep-label mb-0">
            EXPLANATION SECTION (if applicable)
          </label>
          <div>
            <input
              type="text"
              class="mt-1 mb-1 orep-text-input"
              name="explanation1"
              v-model="groupAppraiser.explanation1"
            >
          </div>
          <input
            type="text"
            class="mt-1 mb-1 orep-text-input"
            name="explanation2"
            v-model="groupAppraiser.explanation2"
          >
          <input
            type="text"
            class="mt-1 mb-1 orep-text-input"
            name="explanation3"
            v-model="groupAppraiser.explanation3"
          >
          <input
            type="text"
            class="mt-1 mb-1 orep-text-input"
            name="explanation4"
            v-model="groupAppraiser.explanation4"
          >
          <input
            type="text"
            class="mt-1 mb-1 orep-text-input"
            name="explanation5"
            v-model="groupAppraiser.explanation5"
          >
        </article>
      </form>
    </section>
    <div>
      <div class="row">
        <div class="col-md-12">
          <section class="flex wrap bottom-section">
            <router-link :to="{name:'group-appraiser-2'}" class="next-btn back-btn flex mont spaced">
              <i class="fas fa-arrow-left"></i>
              Back
            </router-link>
            <article class="orep-pagination">
              <button class="pagination-dots" @click="navigateToOne()"></button>
              <button class="pagination-dots" @click="prev()"></button>
              <span class="pagination-dots pagination-current"></span>
              <button class="pagination-dots" @click="navigateToNext('group-appraiser-4')" :disabled="!state.pageThreeIsValid"></button>
            </article>
            <button
              type="submit"
              :disabled="!state.pageThreeIsValid"
              :class="{submitDisabled: !state.pageThreeIsValid}"
              class="next-btn mont spaced pull-right"
              @click="navigateToNext('group-appraiser-4')"
            >Next</button>
          </section>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import $ from "jquery";
import Datepicker from 'vuejs-datepicker';

export default {
  name: "group-appraiser-3",
  computed: {
    groupAppraiser() {
      return this.$store.state.groupAppraiser.groupAppraiser;
    },
    state() {
      return this.$store.state.groupAppraiser;
    },
    errorMsg() {
      return this.$store.state.groupAppraiser.errorMsg;
    }
  },
  watch: {
    errorMsg: {
      handler() {
        if (this.errorMsg) {
          this.$notify({
            group: 'error',
            type: 'error',
            title: 'Error',
            text: this.errorMsg
          });
        }
      }
    }
  },
  methods: {
    desiredCoverage(event) {
      if(!this.groupAppraiser.limitOfCoverages.find(coverage => coverage === event.target.value)) {
        if (this.groupAppraiser.limitOfCoverages.length < 2) {
          this.groupAppraiser.limitOfCoverages.push(event.target.value);
        } else {
          this.$notify({
            group: 'error',
            type: 'warning',
            title: 'Warning',
            text: 'You can select up to 2 coverages.'
          });
        }
      } else {
        this.groupAppraiser.limitOfCoverages = this.groupAppraiser.limitOfCoverages.filter(coverage => coverage !== event.target.value);
      }
    },

    navigateToNext(routeName) {
      this.$router.push({
        name: routeName
      });
    },

    prev() {
      this.$router.push({
        name: "group-appraiser-2"
      });
    },

    navigateToOne() {
      this.$router.push({
        name: "group-appraiser-1"
      });
    },

    validateBeforeSubmit() {
      this.$validator.validateAll().then(result => {
        if (result) {
          this.state.pageThreeIsValid = true;
          return;
        }
        this.state.pageThreeIsValid = false;
      });
    },
  },

  filters: {
    filterText(x) {
      if (x !== undefined) {
        if (x.indexOf("req") !== -1) {
          return "This field is required";
        } else {
          return x.replace("_", " ");
        }
      }
    }
  },

  mounted() {
    $('html, body').animate({
        scrollTop: $('.page-content').offset().top
    }, 500);
  },
  components: {
    Datepicker
  }
};
</script>

<style scoped>
</style>

